<template>
  <div class="page">
    <section class="section content-container">
      <div class="container is-fluid">
        <div class="report-container">
          <FlowTotalsCharts @loaded="handleReportLoad('totals')" />
        </div>

        <div class="report-container island">
          <FlowEngagementCharts @loaded="handleReportLoad('engagement')" />
        </div>

        <div class="report-container island">
          <FlowEscalationRateCharts @loaded="handleReportLoad('escalation')" />
        </div>
      </div>
    </section>
  </div>
</template>

<script lang="ts" setup>
import FlowEscalationRateCharts from '@/features/reports/components/flows/FlowEscalationRateCharts.vue';
import FlowEngagementCharts from '@/features/reports/components/flows/FlowEngagementCharts.vue';
import FlowTotalsCharts from '@/features/reports/components/flows/FlowTotalsCharts.vue';
import { SET_REPORT_LOADING } from '@/store/reports/mutationTypes';
import { useStore } from 'vuex';
import { computed, onMounted, ref, watch } from 'vue';

interface ReportsLoaded {
  totals: boolean;
  engagement: boolean;
  escalation: boolean;
}

const store = useStore();
const selectedDateOption = computed(() => store.getters.selectedDateOption);
const selectedFlowId = computed(() => store.getters.selectedFlowId);

const setReportLoading = (loading: boolean) => store.commit(SET_REPORT_LOADING, loading);

const reportIsLoaded = ref<ReportsLoaded>({
  totals: false,
  engagement: false,
  escalation: false,
});

watch([selectedDateOption, selectedFlowId], () => {
  resetLoadingStatus();
  setReportLoading(true);
});

onMounted(() => setReportLoading(true));

function handleReportLoad(type: keyof ReportsLoaded) {
  reportIsLoaded.value[type] = true;
  if (reportIsLoaded.value.totals && reportIsLoaded.value.engagement && reportIsLoaded.value.escalation) {
    setReportLoading(false);
  }
}

function resetLoadingStatus() {
  reportIsLoaded.value = {
    totals: false,
    engagement: false,
    escalation: false,
  };
}
</script>

<style scoped lang="scss">
.filters {
  margin-bottom: 0.5em;
}

.island {
  height: 560px;
}

.report-container:not(:last-child) {
  margin-bottom: 1.5em;
}
</style>
